import { AuthStore } from '@interfaces/auth.interfaces';
import createStore from 'zustand';

const useAuthStore = createStore<AuthStore>((set) => ({
	loading: true,
	setLoading: (loading) => set({ loading }),
	menus: {},
	setMenus: (menus) => set({ menus }),
	token: null,
	setToken: (token) => set({ token }),
	user: null,
	setUser: (user) => set({ user }),
}));

export default useAuthStore;
